import React, { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import AboutLanding from './home/AboutLanding';
import { useAboutLanding } from './home/useAboutLanding';

const About: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  const lang = language === 'en' ? 'en' : 'cs';
  const v = useAboutLanding(lang);

  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = '';
    };
  }, []);

  return (
    <AboutLanding
      v={v}
      lang={lang}
      onSetCz={() => setLanguage('cs')}
      onSetEn={() => setLanguage('en')}
    />
  );
};

export default About;
